export default "__VITE_ASSET__C6EVW2Hu__"